import { computed, defineComponent, ref } from 'vue';
import { validatorByIconSize } from './../../utils/validator';
export default defineComponent({
    name: 'TLoading',
    props: {
        size: {
            type: String,
            default: 'medium',
            validator: (value) => validatorByIconSize(value),
        },
        theme: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'highlight'].includes(value),
        },
    },
    setup(props, context) {
        // 定义组件类型前辍
        const prefixCls = ref('t-loading');
        // 定义页面需要的className
        const getClasses = computed(() => {
            return {
                wrap: [prefixCls.value, `${prefixCls.value}-size__${props.size}`],
            };
        });
        /** 对外响应的事件 */
        const listener = (event) => context.emit('click', event);
        return { prefixCls, getClasses, listener };
    },
});
